
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { UI_DATE_FORMAT_MAP } from '../global-meta-data';

@Pipe({
  name: 'StringToDateFormatPipe'
})

export class StringToDateFormatPipe implements PipeTransform {

  transform(value: string, type: string, format: string): string {
    if (!value) {
      return '---';
    }

    let dateFormat, returnString;
    dateFormat = UI_DATE_FORMAT_MAP[format] ? UI_DATE_FORMAT_MAP[format] : UI_DATE_FORMAT_MAP['default'];

    if (type === 'addExpiry') {
      returnString = moment(value).format(dateFormat) + ' (' + moment(value).fromNow() + ')';
    } else if (type === 'addExpiryTwoParts') {
      returnString = moment(value).format(dateFormat) +
        ' (' + this.stringifyParsedDiff(moment.duration(moment(value).diff(moment())), 2) + ')';
    } else if (type === 'shortExpiry') {
      returnString = moment(value).fromNow();
    } else if (type === 'bid') {
      returnString = this.stringifyParsedDiff(moment.duration(moment(value).diff(moment())), null);
    } else if (type === 'onlyExpiry') {
      returnString = this.stringifyParsedDiff(moment.duration(moment(value).diff(moment())), null);
    } else if (type === 'onlyExpiryTwoParts') {
      returnString = this.stringifyParsedDiff(moment.duration(moment(value).diff(moment())), 2);
    } else {
      returnString = moment(value).format(dateFormat);
    }
    return returnString;
  }

  stringifyParsedDiff(dateObj, count) {
    const dateObjData = dateObj._data;
    let returnString = '';
    const returnArray = [];
    const isPast = dateObjData.seconds < 0 || dateObjData.minutes < 0 ? ' ago' : '';
    if (dateObjData.years) {
      returnArray.push(Math.abs(dateObjData.years) + 'yrs ');
    }
    if (dateObjData.months) {
      returnArray.push(Math.abs(dateObjData.months) + ' mnths ');
    }
    if (dateObjData.days) {
      returnArray.push(Math.abs(dateObjData.days) + ' days ');
    }
    if (dateObjData.hours) {
      returnArray.push(Math.abs(dateObjData.hours) + ' hrs ');
    }
    if (dateObjData.minutes) {
      returnArray.push(Math.abs(dateObjData.minutes) + ' mins ');
    }

    if (count === 2) {
      returnString = [returnArray[0], returnArray[1]].join('');
    } else {
      returnString = [returnArray[0]].join('');
    }

    return returnString ? returnString + isPast : 'just now';

    // returnString += dateObjData.years ? Math.abs(dateObjData.years) + 'yrs ' : '';
    // if (returnString) { return returnString + isPast; }
    // returnString += dateObjData.months ? Math.abs(dateObjData.months) + ' mnths ' : '';
    // if (returnString) { return returnString + isPast; }
    // returnString += dateObjData.days ? Math.abs(dateObjData.days) + ' days ' : '';
    // if (returnString) { return returnString + isPast; }

    // returnString += dateObjData.hours ? Math.abs(dateObjData.hours) + ' hrs ' : '';
    // if (returnString) { return returnString + isPast; }

    // returnString += dateObjData.minutes ? Math.abs(dateObjData.minutes) + ' mins ' : '';
    // if (returnString) { return returnString + isPast; }
  }

}
